<template>
  <global-modal-setting
    :active.sync="showSurat.isActive"
    @toggleActive="toggleShowSurat"
    :disableClose="true"
    :zIndex="'500000'"
    :classModal="'w-full h-full'"
  >
    <div slot="header">
      <div class="w-full flex items-center">
        <div class="h4 text-white flex-1">Atur Surat</div>
        <div class="flex justify-between">
          <vs-button @click="toggleShowSurat(false)" type="border" class="mr-2"
            >Keluar</vs-button
          >
          <!-- <vs-button @click="saveSettingSurat">Simpan</vs-button> -->
        </div>
      </div>
    </div>
    <div class="w-full flex justify-center items-center pt-20" v-if="loading">
      <img
        src="/images/icons/loading.gif"
        class="w-full md:w-1/3"
        alt="Memuat data"
      />
    </div>
    <div v-show="!loading" class="w-full relative overflow-x-hidden">
      <div
        id="canvas_container"
        class="w-full relative flex justify-center p-5"
        style="padding-bottom: 200px !important"
      >
        <canvas ref="pdf"></canvas>
        <canvas v-show="grid" id="grid" class="absolute"></canvas>
      </div>
      <konva-layer
        v-if="signature"
        :konvaConfig="configKonva"
        :signature="signature"
        @updateManifest="updateManifest"
        @deleteSign="handleDeleteSign"
      ></konva-layer>
      <div
        class="flex justify-between fixed right-0 left-0 bottom-0 p-3 shadow-lg"
        style="background-color: #2b2e36"
      >
        <div class="flex-initial flex items-center">
          <vs-input-number
            v-model="page"
            :min="1"
            :max="maxPages"
            icon-inc="navigate_next"
            icon-dec="navigate_before"
          />
        </div>

        <div class="btn-group">
          <!-- <vs-button size="small" class="p-0" @click="setScale('-')">
            <feather-icon icon="ZoomOutIcon" svgClasses="h-5 w-5" />
          </vs-button>
          <vs-button size="small" @click="setScale('+')">
            <feather-icon icon="ZoomInIcon" svgClasses="h-5 w-5" />
          </vs-button> -->
          <!-- <vs-button size="small" @click="toggleFormSignature(true)">
            <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5" />
          </vs-button> -->
          <vs-button size="small" @click="toggleGrid()">
            <feather-icon icon="GridIcon" svgClasses="h-5 w-5" />
          </vs-button>
        </div>
      </div>
    </div>
    <form-signature
      @callbackUsers="handleSignatures"
      :documentId="this.documentId"
    ></form-signature>
  </global-modal-setting>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { digofHttp as axios } from "@/axios";

let pdfjsLib = require("pdfjs-dist");

pdfjsLib.GlobalWorkerOptions.workerSrc =
  "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js";

import FormSignature from "./FormSignature.vue";
import KonvaLayer from "./KonvaLayer.vue";

export default {
  components: {
    FormSignature,
    KonvaLayer
  },
  data() {
    return {
      loading: false,
      grid: 0,
      scale: 1.0,
      page: "1",
      maxPages: 1,
      dokumen: [],
      configKonva: {
        width: 200,
        height: 200
      },
      signatures: [],
      selecteduserTemplate: ""
    };
  },
  computed: {
    ...mapState({
      showSurat: state => state.surat.showSurat
    }),
    signature() {
      const index = this.findSignatureIndex();
      if (index == -1) return {};
      else return this.signatures[index];
    },
    documentId() {
      // return this.dokumen.dokumen ? this.dokumen.dokumen.uuid : "-";
      return this.$route.params.uuid;
    }
  },

  watch: {
    "showSurat.isActive": {
      handler(bol) {
        if (bol) {
          this.$nextTick().then(() => {
            this.setDefault();
            this.fetchDocument();
          });
        }
      }
    },
    page(val) {
      console.log(val);
      console.log("[Page Change]");
      this.initPdf();
    }
  },

  mounted() {
    console.log("[Component Mounted]");
  },

  methods: {
    async fetchDocument() {
      try {
        console.log("[Fetch Dokument PDF]");
        this.loading = true;
        const response = await axios({
          url: `surat-keluar/download/${this.showSurat.suratId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.$sanctum.getToken()}`
          }
        });
        this.loading = false;
        console.log(`[Fetched] ${response}`);
        this.dokumen = response.data.data;
        const attribute = response.data.data.dokumen.attribute;
        await this.parseDocumentAttributes(attribute);
      } catch (e) {
        console.log(e);
        this.$vs.dialog({
          color: "danger",
          title: "Error 500",
          text: "File tidak ditemukan, silakan coba lagi atau hubungi Tim IT"
        });
        this.toggleShowSurat(false);
      }
      await this.initPdf();
    },
    async parseDocumentAttributes(attr) {
      let signs = [];
      if (attr) {
        if (attr.signs) {
          signs = attr.signs;
        }
      }
      this.signatures = signs;
    },
    initPdf() {
      console.log(`Initialize PDF`);
      var canvas = this.$refs.pdf.getContext("2d");
      console.log(`[PDF Data Loaded]`);
      let loader = pdfjsLib.getDocument(
        `data:application/pdf;base64,${this.dokumen.pdf}`
      );

      loader.promise.then(pdf => {
        this.maxPages = pdf.numPages;

        const page = parseInt(this.page);

        pdf.getPage(page).then(page => {
          let scale = this.scale;
          let viewport = page.getViewport({ scale });
          let context = canvas;

          let renderContext = {
            canvasContext: context,
            viewport: viewport
          };

          let render = page.render(renderContext);
          render.promise.then(() => {});

          this.setPdfLayout({
            width: viewport.width,
            height: viewport.height
          });

          this.setKonvaLayout({
            width: viewport.width,
            height: viewport.height
          });

          this.setGrid({
            canvasWidth: viewport.width,
            canvasHeight: viewport.height
          });
        });
      });
    },
    setPdfLayout({ width, height }) {
      this.$refs.pdf.width = width;
      this.$refs.pdf.height = height;
    },
    setKonvaLayout({ width, height }) {
      this.configKonva = {
        width: width,
        height: height
      };
    },
    setGrid({ canvasWidth, canvasHeight }) {
      let canvas = document.getElementById("grid");
      canvas.height = canvasHeight;
      canvas.width = canvasWidth;

      let ctx = canvas.getContext("2d");

      let gridBox = 20;

      for (var x = 0; x < canvasWidth; x += gridBox) {
        ctx.moveTo(x, 0);
        ctx.lineTo(x, canvasHeight);
      }

      for (var y = 0; y < canvasHeight; y += gridBox) {
        ctx.moveTo(0, y);
        ctx.lineTo(canvasWidth, y);
      }

      ctx.strokeStyle = "#05a4e0";
      ctx.stroke();
    },
    setDefault() {
      this.page = 1;
      this.maxPages = 1;
      this.grid = false;
      this.scale = 1.0;
    },
    setScale(val) {
      if (val === "+") this.scale += 0.1;
      else this.scale -= 0.1;
      console.log("[Set Scale]");
      this.initPdf();
    },
    async handleSignatures(user) {
      // add pages before push manifest if pages not exists
      if (this.findSignatureIndex() == -1) await this.addSignaturePage();

      const signatureIndex = this.findSignatureIndex();
      this.addManifest({
        user: user,
        index: signatureIndex
      });
    },
    findSignatureIndex() {
      return this.signatures.findIndex(i => i.page == this.page);
    },
    addSignaturePage() {
      const signature = { page: this.page, manifest: [] };
      this.signatures.push(signature);
    },
    addManifest({ user, index }) {
      const manifest = {
        userId: user.uuid,
        userTemplate: user.template,
        canvasHeight: this.configKonva.height,
        canvasWidth: this.configKonva.width
      };

      const findIndex = this.signatures[index].manifest.findIndex(
        i => i.userId == user.uuid
      );

      if (findIndex == -1) this.signatures[index].manifest.push(manifest);
    },
    updateManifest({ data, manifestIndex }) {
      const index = this.findSignatureIndex();
      const manifest = this.signatures[index].manifest[manifestIndex];
      const newManifest = { ...manifest, ...data };

      this.signatures[index].manifest[manifestIndex] = newManifest;
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    handleDeleteSign(manifestIndex) {
      const index = this.findSignatureIndex();
      this.signatures[index].manifest.splice(manifestIndex, 1);
    },
    toggleGrid() {
      this.grid = !this.grid;
    },
    toggleAddTTE(val) {
      this.showAddTTE = val;
    },
    async saveSettingSurat() {
      const data = {
        signs: {
          ...this.signatures
        }
      };
      await axios({
        url: `surat-keluar/attribute/${this.dokumen.dokumen.uuid}`,
        method: "post",
        data: data,
        headers: {
          Authorization: `Bearer ${this.$sanctum.getToken()}`
        }
      });
      this.toggleShowSurat(false);
    },
    ...mapActions({
      toggleShowSurat: "surat/toggleShowSurat",
      toggleFormSignature: "surat/toggleFormSignature"
    })
  }
};
</script>

<style lang="scss"></style>
